import { throttle } from 'lodash-es';
import { numberToHumanSize } from '~/lib/utils/number_utils';
import { encodeSaferUrl } from '~/lib/utils/url_utility';
const BLOB_PREFIX = 'blob:';
export default {
    name: 'ImageViewer',
    props: {
        path: {
            type: String,
            required: true
        },
        fileSize: {
            type: Number,
            required: false,
            default: 0
        },
        renderInfo: {
            type: Boolean,
            default: true,
            required: false
        },
        innerCssClasses: {
            type: [
                Array,
                Object,
                String
            ],
            required: false,
            default: ''
        },
        encodePath: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'img-loaded'
    ],
    data () {
        return {
            width: 0,
            height: 0,
            renderedWidth: 0,
            renderedHeight: 0
        };
    },
    computed: {
        fileSizeReadable () {
            return numberToHumanSize(this.fileSize);
        },
        hasFileSize () {
            return this.fileSize > 0;
        },
        hasDimensions () {
            return this.width && this.height;
        },
        safePath () {
            if (!this.encodePath) return this.path;
            return this.path.startsWith(BLOB_PREFIX) ? this.path : encodeSaferUrl(this.path);
        }
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.resizeThrottled, false);
    },
    mounted () {
        // The onImgLoad may have happened before the control was actually mounted
        this.onImgLoad();
        this.resizeThrottled = throttle(this.onImgLoad, 400);
        window.addEventListener('resize', this.resizeThrottled, false);
    },
    methods: {
        onImgLoad () {
            requestIdleCallback(this.calculateImgSize, {
                timeout: 1000
            });
        },
        calculateImgSize () {
            const { contentImg } = this.$refs;
            if (contentImg) {
                this.width = contentImg.naturalWidth;
                this.height = contentImg.naturalHeight;
                this.$nextTick(()=>{
                    this.renderedWidth = contentImg.clientWidth;
                    this.renderedHeight = contentImg.clientHeight;
                    this.$emit('img-loaded', {
                        width: this.width,
                        height: this.height,
                        renderedWidth: this.renderedWidth,
                        renderedHeight: this.renderedHeight
                    });
                });
            }
        }
    }
};
